/*
  Rescuevation: EV-Premium-Familie (evp)
  Progressive Erweiterung. Ohne dieses Script ist jede Section fertig und
  lesbar: alle Einsatzlagen stehen untereinander, Zahlen tragen ihren
  Endwert, der Baukasten zeigt die serverseitig gerechnete Vorauswahl.

  Module:
  - Reiter      Einsatzlagen als Tabs (WAI-ARIA tablist, Pfeiltasten)
  - Sichtbar    setzt einmal .evp-ist-sichtbar (startet die Schema-Animation)
  - Zaehler     zählt reine Zahlen einmal hoch
  - Sprung      markiert die Marke des sichtbaren Abschnitts
  - Verlauf     füllt die Achse des Einsatzverlaufs beim Scrollen
  - Video       lädt YouTube erst auf Klick (youtube-nocookie)
  - Baukasten   rechnet Summe, Set-Vorteil und Brutto live
  - Anfrage     schreibt Paket bzw. Auswahl ins Angebotsformular
*/
(function () {
  if (window.RescuEvp) return;

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function euro(cent) {
    var wert = (Math.round(cent) / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return wert + ' €';
  }

  // Eigener Präfix "evpIni...": dataset.evpVideo wäre sonst dasselbe Attribut
  // wie data-evp-video und würde die Video-ID überschreiben.
  function einmal(el, schluessel) {
    var k = 'evpIni' + schluessel.replace(/^evp/, '');
    if (el.dataset[k] === '1') return false;
    el.dataset[k] = '1';
    return true;
  }

  /* ---------- Reiter ---------- */

  function reiter(root) {
    if (!einmal(root, 'evpReiter')) return;
    var leiste = root.querySelector('.evp-lagen__reiter');
    if (!leiste) return;
    var tabs = Array.prototype.slice.call(leiste.querySelectorAll('[role="tab"]'));
    var paneele = tabs.map(function (t) {
      return document.getElementById(t.getAttribute('aria-controls'));
    });
    if (!tabs.length || paneele.indexOf(null) !== -1) return;

    function waehle(i, fokus, animiert) {
      tabs.forEach(function (t, n) {
        var an = n === i;
        t.setAttribute('aria-selected', an ? 'true' : 'false');
        t.tabIndex = an ? 0 : -1;
        paneele[n].hidden = !an;
        paneele[n].classList.remove('is-neu');
      });
      if (animiert) {
        void paneele[i].offsetWidth;
        paneele[i].classList.add('is-neu');
      }
      if (fokus) tabs[i].focus();
    }

    leiste.hidden = false;
    root.classList.add('is-reiter');

    var start = 0;
    paneele.forEach(function (p, n) {
      if (location.hash && location.hash.slice(1) === p.id) start = n;
    });
    waehle(start, false, false);

    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () {
        waehle(n, false, true);
      });
      t.addEventListener('keydown', function (e) {
        var ziel = null;
        if (e.key === 'ArrowRight') ziel = (n + 1) % tabs.length;
        if (e.key === 'ArrowLeft') ziel = (n - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') ziel = 0;
        if (e.key === 'End') ziel = tabs.length - 1;
        if (ziel !== null) {
          e.preventDefault();
          waehle(ziel, true, true);
        }
      });
    });

    // Sprunglinks auf eine Einsatzlage (#lage-...) öffnen deren Reiter,
    // bevor der Browser scrollt.
    document.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest && e.target.closest('a[href^="#"]');
        if (!a) return;
        var id = a.getAttribute('href').slice(1);
        var n = paneele.findIndex(function (p) {
          return p.id === id;
        });
        if (n !== -1) waehle(n, false, true);
      },
      true
    );
    window.addEventListener('hashchange', function () {
      var n = paneele.findIndex(function (p) {
        return p.id === location.hash.slice(1);
      });
      if (n !== -1) waehle(n, false, true);
    });
  }

  /* ---------- Sichtbar + Zaehler ---------- */

  function zaehle(el) {
    var ziel = (el.textContent || '').trim();
    if (!/^\d{1,6}$/.test(ziel)) return;
    var endwert = parseInt(ziel, 10);
    if (endwert < 2) return;
    var dauer = 1300;
    var t0 = null;
    function schritt(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dauer);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(endwert * e));
      if (p < 1) requestAnimationFrame(schritt);
      else el.textContent = ziel;
    }
    requestAnimationFrame(schritt);
  }

  function sichtbar(root) {
    if (!einmal(root, 'evpSichtbar')) return;
    function los() {
      root.classList.add('evp-ist-sichtbar');
      if (!ruhig) root.querySelectorAll('[data-evp-zaehler]').forEach(zaehle);
    }
    if (!('IntersectionObserver' in window)) {
      root.classList.add('evp-ist-sichtbar');
      return;
    }
    var io = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) {
            io.disconnect();
            los();
          }
        });
      },
      { threshold: 0.25 }
    );
    io.observe(root);
  }

  /* ---------- Sprungleiste ---------- */

  function sprung(nav) {
    if (!einmal(nav, 'evpSprung')) return;
    var liste = nav.querySelector('.evp-sprung__liste');
    var links = Array.prototype.slice.call(nav.querySelectorAll('.evp-sprung__link'));
    var ziele = links
      .map(function (a) {
        return { a: a, el: document.getElementById(a.getAttribute('href').slice(1)) };
      })
      .filter(function (z) {
        return z.el;
      });
    if (!ziele.length || !('IntersectionObserver' in window)) return;

    var aktiv = null;
    function setze(a) {
      if (a === aktiv) return;
      if (aktiv) aktiv.removeAttribute('aria-current');
      aktiv = a;
      if (!a) {
        // Oberhalb des ersten Abschnitts: Liste wieder an den Anfang, sonst
        // steht mobil nur noch das Ende der Liste ("Fragen") im Bild.
        if (liste) liste.scrollTo({ left: 0, behavior: ruhig ? 'auto' : 'smooth' });
        return;
      }
      a.setAttribute('aria-current', 'true');
      if (liste && liste.scrollWidth > liste.clientWidth) {
        liste.scrollTo({ left: Math.max(0, a.offsetLeft - 24), behavior: ruhig ? 'auto' : 'smooth' });
      }
    }

    var sichtbare = new Map();
    var io = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) sichtbare.set(e.target, true);
          else sichtbare.delete(e.target);
        });
        var treffer = null;
        ziele.forEach(function (z) {
          if (sichtbare.has(z.el)) treffer = treffer || z.a;
        });
        setze(treffer);
      },
      { rootMargin: '-40% 0px -55% 0px' }
    );
    ziele.forEach(function (z) {
      io.observe(z.el);
    });
  }

  /* ---------- Verlauf ---------- */

  function verlauf(root) {
    if (!einmal(root, 'evpVerlauf')) return;
    var strecke = root.querySelector('.evp-verlauf__strecke');
    var abschnitte = Array.prototype.slice.call(root.querySelectorAll('.evp-abschnitt'));
    if (!strecke) return;
    root.classList.add('is-aktiv');
    var geplant = false;
    function rechne() {
      geplant = false;
      var r = strecke.getBoundingClientRect();
      var mitte = window.innerHeight * 0.55;
      var p = (mitte - r.top) / Math.max(1, r.height);
      p = Math.max(0, Math.min(1, p));
      root.style.setProperty('--evp-fortschritt', p.toFixed(3));
      abschnitte.forEach(function (a) {
        a.classList.toggle('is-vor', a.getBoundingClientRect().top > mitte);
      });
    }
    function plane() {
      if (!geplant) {
        geplant = true;
        requestAnimationFrame(rechne);
      }
    }
    window.addEventListener('scroll', plane, { passive: true });
    window.addEventListener('resize', plane);
    rechne();
  }

  /* ---------- Video ---------- */

  function video(box) {
    if (!einmal(box, 'evpVideo')) return;
    var start = box.querySelector('.evp-video__start');
    var id = box.getAttribute('data-evp-video');
    if (!start || !/^[\w-]{6,20}$/.test(id)) return;
    start.addEventListener('click', function (e) {
      e.preventDefault();
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = (start.querySelector('.evp-video__label') || {}).textContent || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture';
      f.allowFullscreen = true;
      box.appendChild(f);
      start.remove();
    });
  }

  /* ---------- Baukasten ---------- */

  function baukasten(root) {
    if (!einmal(root, 'evpBaukasten')) return;
    var rabatt = parseFloat(root.getAttribute('data-rabatt') || '0');
    var optionen = Array.prototype.slice.call(root.querySelectorAll('[data-evp-option]'));
    var feld = function (sel) {
      return root.querySelector(sel);
    };
    var cta = feld('[data-evp-bk-cta]');

    function wahl(opt) {
      var sel = opt.querySelector('[data-evp-variante]');
      if (sel) {
        var o = sel.options[sel.selectedIndex];
        return { preis: parseInt(o.getAttribute('data-preis'), 10) || 0, titel: o.getAttribute('data-titel') || '' };
      }
      var fest = opt.querySelector('[data-evp-variante-fest]');
      return {
        preis: fest ? parseInt(fest.getAttribute('data-preis'), 10) || 0 : 0,
        titel: fest ? fest.getAttribute('data-titel') || '' : ''
      };
    }

    function puls(el) {
      if (!el || ruhig) return;
      el.classList.remove('evp-puls');
      void el.offsetWidth;
      el.classList.add('evp-puls');
    }

    function rechne(animiert) {
      var summe = 0;
      var teile = 0;
      var namen = [];
      optionen.forEach(function (opt) {
        var check = opt.querySelector('[data-evp-check]');
        var w = wahl(opt);
        var preisEl = opt.querySelector('[data-evp-preis]');
        if (preisEl) preisEl.textContent = euro(w.preis);
        var an = check && check.checked;
        opt.classList.toggle('is-gewaehlt', !!an);
        if (an) {
          summe += w.preis;
          teile += 1;
          namen.push(opt.getAttribute('data-name') + (w.titel && w.titel !== 'Default Title' ? ' (' + w.titel + ')' : ''));
        }
      });
      var set = teile > 1 ? Math.round((summe * (100 - rabatt)) / 100) : summe;
      var ersparnis = summe - set;

      feld('[data-evp-teile]').textContent = String(teile);
      feld('[data-evp-einzeln]').textContent = euro(summe);
      feld('[data-evp-ersparnis]').textContent = '−' + euro(ersparnis);
      feld('[data-evp-setzeile]').classList.toggle('is-aus', teile < 2);
      feld('[data-evp-set]').textContent = euro(set);
      feld('[data-evp-brutto]').textContent = euro(Math.round(set * 1.19));
      if (animiert) puls(feld('.evp-bk__gesamt-wert'));

      if (cta) {
        var text = teile
          ? 'Paket-Baukasten: ' + namen.join(' + ') + '. Paketpreis ' + euro(set) + ' netto' + (teile > 1 ? ' (−' + rabatt + ' %)' : '') + '.'
          : '';
        cta.setAttribute('data-evp-anfrage', text);
      }
    }

    optionen.forEach(function (opt) {
      opt.addEventListener('change', function () {
        rechne(true);
      });
    });
    rechne(false);
  }

  /* ---------- Anfrage ins Formular ---------- */

  function anfrageVorbereiten() {
    var form = document.getElementById('ContactForm');
    if (!form || form.dataset.evpSeite === '1') return;
    form.dataset.evpSeite = '1';
    if (!form.querySelector('[name="contact[Produkt]"]') && !form.querySelector('[name="contact[Seite]"]')) {
      var seite = document.createElement('input');
      seite.type = 'hidden';
      seite.name = 'contact[Seite]';
      seite.value = document.title.split('–')[0].trim() + ' – ' + location.origin + location.pathname;
      form.appendChild(seite);
    }
  }

  function anfrageKlick(e) {
    var a = e.target.closest && e.target.closest('[data-evp-anfrage]');
    if (!a) return;
    var text = a.getAttribute('data-evp-anfrage');
    var form = document.getElementById('ContactForm');
    if (!form || !text) return;
    var feld = form.querySelector('textarea[name="contact[Nachricht]"]');
    if (feld && (!feld.value.trim() || feld.dataset.evpVorbelegt === '1')) {
      feld.value = text + '\n\n';
      feld.dataset.evpVorbelegt = '1';
      feld.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var versteckt = form.querySelector('input[name="contact[Paket]"]');
    if (!versteckt) {
      versteckt = document.createElement('input');
      versteckt.type = 'hidden';
      versteckt.name = 'contact[Paket]';
      form.appendChild(versteckt);
    }
    versteckt.value = text;
    var name = form.querySelector('input[name="contact[Name]"]');
    if (name) {
      setTimeout(function () {
        name.focus({ preventScroll: true });
      }, ruhig ? 0 : 650);
    }
  }

  /* ---------- Start ---------- */

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-evp-lagen]').forEach(reiter);
    s.querySelectorAll('[data-evp-sichtbar]').forEach(sichtbar);
    s.querySelectorAll('[data-evp-sprung]').forEach(sprung);
    s.querySelectorAll('[data-evp-verlauf]').forEach(verlauf);
    s.querySelectorAll('[data-evp-video]').forEach(video);
    s.querySelectorAll('[data-evp-baukasten]').forEach(baukasten);
    anfrageVorbereiten();
  }

  window.RescuEvp = { init: init };
  document.addEventListener('click', anfrageKlick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
